import ApiDefault from "../../ApiDefault";

export default function ApiVariables() {
    const apiDefault = ApiDefault("v2/system/variables");

    // Query
    const menu = async (menu) => {
        let urlCustom = `/${apiDefault.url}/menu?menu=${menu}&orderby=created_at-desc`;

        return await apiDefault.api
            .get(urlCustom)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    return {
        apiDefault,
        menu,
    };
}
